export default __webpack_public_path__ + "static/media/404-illustration-mobile.d6812676.svg";